export default {
    props:{
        width: {
        type: String,
        default: '16px'
        },
        height: {
        type: String,
        default: '16px'
        },
    },
    setup(props){
        return props
    }
}
  